export default __webpack_public_path__ + "static/media/icons8-twitter-circled.292884df.gif";